import { Button, Checkbox, Flex, Table, Text } from '@mantine/core'
import classes from './AdminSettings.module.css'

const MOCK_DATA = Array(6).fill({
  label: 'Permission set label',
})

export const CustomFieldsControlFieldLevelSecurity = () => {
  const rows = MOCK_DATA.map((item) => (
    <Table.Tr key={item.label}>
      <Table.Td style={{ whiteSpace: 'pre' }}>{item.label}</Table.Td>
      <Table.Td style={{ whiteSpace: 'pre' }}>
        <Checkbox />
      </Table.Td>
      <Table.Td style={{ whiteSpace: 'pre' }}>
        <Checkbox />
      </Table.Td>
    </Table.Tr>
  ))

  return (
    <>
      <Table withRowBorders={false} verticalSpacing="xs">
        <Table.Thead>
          <Table.Tr className={classes.AdminSettings__thead}>
            <Table.Th key={`columns-1`} style={{ whiteSpace: 'pre' }}>
              <Text size="xs" c="black">
                Permission sets
              </Text>
            </Table.Th>

            <Table.Th key={`columns-2`} style={{ whiteSpace: 'pre' }}>
              <Checkbox
                label={
                  <Text size="xs" mt={3}>
                    Read access
                  </Text>
                }
              />
            </Table.Th>

            <Table.Th key={`columns-2`} style={{ whiteSpace: 'pre' }}>
              <Checkbox
                label={
                  <Text size="xs" mt={3}>
                    Edit access
                  </Text>
                }
              />
            </Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>{rows}</Table.Tbody>
      </Table>
      <Flex p="md" mt="lg" justify="flex-start" gap="xs">
        <Button size="md" variant="default">
          Cancel
        </Button>
        <Button size="md">Create New Custom Field</Button>
      </Flex>
    </>
  )
}
